// Mirrors the server's monogram rule (Server/src/controllers/invoice/
// invoice.vendor-branding.ts) so the preview in the vendor profile matches
// what actually prints on the invoice: "Four Corner Services" -> "FCS".
const STOP_WORDS = new Set(["and", "of", "the", "for", "inc", "ltd", "llc", "corp"]);

export function monogramInitials(name) {
  const words = String(name || "")
    .replace(/\s+/g, " ")
    .trim()
    .split(/[^A-Za-z0-9]+/)
    .filter(Boolean);
  if (!words.length) return "";
  const meaningful = words.filter((w) => !STOP_WORDS.has(w.toLowerCase()));
  const pool = meaningful.length ? meaningful : words;
  if (pool.length === 1) return pool[0].slice(0, 2).toUpperCase();
  return pool
    .slice(0, 3)
    .map((w) => w[0])
    .join("")
    .toUpperCase();
}
